var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 10.4997C2.66666 10.4997 3.33332 9.83301 5.33332 9.83301C7.33332 9.83301 8.66666 11.1663 10.6667 11.1663C12.6667 11.1663 13.3333 10.4997 13.3333 10.4997V2.49967C13.3333 2.49967 12.6667 3.16634 10.6667 3.16634C8.66666 3.16634 7.33332 1.83301 5.33332 1.83301C3.33332 1.83301 2.66666 2.49967 2.66666 2.49967V10.4997ZM2.66666 10.4997V15.1663",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.4211828e36b645d27366c1a119bf1794.svg";
export { ForwardRef as ReactComponent };